import { FormLabel, Checkbox as MuiCheckbox, FormHelperText, Box } from '@mui/material';
import React from 'react';

import { CheckboxProps } from './types';

const Checkbox = ({ error, helperText, label, ...props }: CheckboxProps) => {
  return (
    <Box>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <MuiCheckbox {...props} />
        <FormLabel>{label}</FormLabel>
      </Box>
      <FormHelperText error={error}> {helperText} </FormHelperText>
    </Box>
  );
};

Checkbox.displayName = 'Checkbox';

export default Checkbox;
